export const queryKeys = {
    userInfo: ['userInfo'] as const,
    department: ['department'] as const,
    group: ['group'] as const,
    branch: ['branch'] as const,
    person: ['person'] as const,
    userMessage: ['userMessage'] as const,
}